<template>
  <div class="homeDia" >
    <div class="mm"   data-scrollbar>
        <p>{{$t('home').about.text4}}</p>
    </div>
  </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  import {getProductsUrl} from '../util/lang'
  export default {
    name: "aboutDia",
    data(){
      return{
      }
    },
    mounted(){
      Scrollbar.initAll();
    }
  }
</script>

<style lang="scss" scoped>
  .homeDia{
    width:100%;
    margin: 0 auto;
    .mm{
      width:100%;
      height:108px;
        p{
            font-family: "SOURCEHANSANSCN-LIGHT";
            line-height: 36px;
            width:80%;
            margin: 0 auto;
        }
    }
    @media screen and (max-width: 1000px){
     width:100%;
    }
  }
  @media screen and (max-width: 1024px) {
    .homeDia .mm {
            height: auto !important;
            overflow: unset !important;
            padding-top: 30px !important;
        }
  }
</style>
<style scoped>
  .html >>> p img{
    width:100%;
    object-fit: cover;
  }
</style>
